/* global window */
const ApiActions = require('../../../actions/api');
const Constants = require('./constants');
const Store = require('./store');


class Actions {
    static sendRequest(data) {

        ApiActions.post(
            '/api/signup',
            data,
            Store,
            Constants.REGISTER,
            Constants.REGISTER_RESPONSE,
            (err, response) => {

                if (!err) {
                    window.location.href = '/';
                }
            }
        );
    }
};


module.exports = Actions;



// WEBPACK FOOTER //
// client/pages/main/signup-popup/actions.js